module.exports = __webpack_public_path__ + "img/doc.15b68d4a.svg";